/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthWidgetOperation } from '../../models/auth-widget-operation';

export interface GetAllAuthWidgetFunctionOperation$Params {
}

export function getAllAuthWidgetFunctionOperation(http: HttpClient, rootUrl: string, params?: GetAllAuthWidgetFunctionOperation$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuthWidgetOperation>>> {
  const rb = new RequestBuilder(rootUrl, getAllAuthWidgetFunctionOperation.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AuthWidgetOperation>>;
    })
  );
}

getAllAuthWidgetFunctionOperation.PATH = '/api/AclRole/role/list/authWidgetOperation';
